import React from 'react';
import AdminLayout from './AdminLayout/AdminLayout';
import AuthLayout from './AuthLayout/AuthLayout';
import PublicLayout from './PublicLayout/PublicLayout';

export enum PageLayoutType {
  'admin' = 'admin',
  'auth' = 'auth',
  'public' = 'public',
}

type LayoutFactoryProps = {
  variant: PageLayoutType;
};

export const LayoutFactory = ({ variant }: LayoutFactoryProps) => {
  switch (variant) {
    case PageLayoutType.admin:
      return <AdminLayout />;
    case PageLayoutType.auth:
      return <AuthLayout />;
    case PageLayoutType.public:
      return <PublicLayout />;
    default:
      return null;
  }
};
